const fr = {
  "srv_general_unknown": "Une erreur s'est produite. Veuillez réessayer.",
  "srv_general_network": "Erreur réseau. Vérifiez votre connexion.",
  "srv_general_timeout": "La demande a expiré. Veuillez réessayer.",
  "srv_general_not_found": "Introuvable",
  "srv_general_invalid_id": "ID invalide",
  "srv_general_invalid_json": "JSON invalide",
  "srv_auth_admin_only": "Administrateurs uniquement",
  "srv_auth_owner_only": "Accès réservé au propriétaire",
  "srv_auth_unauthorized": "Non autorisé",
  "srv_auth_not_authenticated": "Non authentifié",
  "srv_auth_invalid_token": "Token invalide",
  "srv_auth_session_expired": "Aucun refresh token",
  "srv_auth_token_expired": "Token expiré",
  "srv_auth_device_signed_out": "Cet appareil a été déconnecté",
  "srv_auth_invalid_login": "Nom d'utilisateur/e-mail ou mot de passe invalide",
  "srv_auth_wrong_password": "Le mot de passe actuel est incorrect",
  "srv_auth_email_already_exists": "E-mail déjà enregistré",
  "srv_auth_email_taken_other": "Cet e-mail est désormais utilisé par un autre compte",
  "srv_auth_same_email": "C'est déjà votre e-mail",
  "srv_auth_same_username": "C'est déjà votre nom d'utilisateur",
  "srv_auth_username_taken": "Nom d'utilisateur déjà utilisé",
  "srv_auth_username_invalid": "Le nom d'utilisateur doit contenir 3 à 20 lettres, chiffres ou underscores",
  "srv_auth_user_not_found": "Utilisateur introuvable",
  "srv_auth_password_mismatch": "Les mots de passe ne correspondent pas",
  "srv_auth_password_weak": "Le nouveau mot de passe doit comporter au moins 8 caractères, dont une lettre et un chiffre",
  "srv_auth_password_same": "Le nouveau mot de passe doit être différent du mot de passe actuel",
  "srv_auth_rate_limited": "Trop de tentatives. Réessayez plus tard.",
  "srv_auth_signup_rate_limited": "Trop d'inscriptions depuis ce réseau. Réessayez plus tard.",
  "srv_auth_verify_link_invalid": "Lien de vérification invalide ou déjà utilisé",
  "srv_auth_verify_link_expired": "Le lien de vérification a expiré. Demandez-en un nouveau.",
  "srv_auth_email_already_verified": "E-mail déjà vérifié.",
  "srv_auth_verification_sent": "E-mail de vérification envoyé.",
  "srv_auth_email_change_sent": "Lien de vérification envoyé au nouvel e-mail. Confirmez-le pour finaliser la modification.",
  "srv_auth_reset_link_invalid": "Lien de réinitialisation invalide ou expiré",
  "srv_auth_reset_sent": "Si le compte existe, un lien de réinitialisation a été envoyé.",
  "srv_auth_password_updated": "Mot de passe mis à jour. Connectez-vous avec votre nouveau mot de passe.",
  "srv_auth_password_changed": "Mot de passe modifié. Reconnectez-vous sur vos autres appareils.",
  "srv_auth_signed_out_all": "Déconnecté de tous les appareils",
  "srv_auth_signed_out_others": "Déconnecté de tous les autres appareils",
  "srv_auth_device_revoked": "Appareil déconnecté",
  "srv_subscription_required": "Cette fonctionnalité est réservée aux membres Premium",
  "srv_subscription_plan_unavailable": "Le forfait d'essai n'est pas disponible.",
  "srv_subscription_order_not_found": "Commande introuvable",
  "srv_payment_provider_unreachable": "Impossible de joindre le prestataire de paiement. Réessayez.",
  "srv_payment_invoice_failed": "Le prestataire de paiement n'a pas pu créer la facture. Réessayez.",
  "srv_payment_not_configured": "La passerelle de paiement crypto n'est pas encore configurée. Ajoutez les clés API NOWPayments.",
  "srv_payment_invalid_signature": "Signature invalide",
  "srv_exchange_connection_not_found": "Connexion introuvable",
  "srv_exchange_unsupported": "Exchange non pris en charge",
  "srv_exchange_unreachable": "Exchange inaccessible depuis le serveur",
  "srv_exchange_key_not_readonly": "Cette clé API dispose des autorisations de trading/retrait. Créez une clé READ-ONLY (désactivez Trade et Withdraw).",
  "srv_exchange_verify_first": "Vérifiez la connexion avant d'activer le trading en direct",
  "srv_insufficient_balance": "Le montant dépasse votre solde disponible",
  "srv_trade_amount_positive": "Le montant doit être supérieur à 0",
  "srv_trade_invalid_withdrawal": "Montant de retrait invalide",
  "srv_trade_bot_needs_tp_sl": "Le bot nécessite un Stop Loss et un Take Profit",
  "srv_trade_no_position": "Aucune position ouverte à vendre",
  "srv_trade_position_not_found": "Position introuvable",
  "srv_trade_symbol_required": "Le symbole est requis",
  "srv_trade_invalid_symbol": "Symbole invalide",
  "srv_trade_invalid_interval": "Intervalle non valide",
  "srv_trade_verify_email": "Veuillez vérifier votre e-mail avant d’ouvrir des trades.",
  "srv_trade_verify_email_auto": "Veuillez vérifier votre e-mail avant d’activer l’auto-trade.",
  "srv_trade_demo_min": "Le solde démo minimum est de 100",
  "srv_trade_demo_max": "Le solde démo est trop élevé (max 10,000,000)",
  "srv_trade_leverage_confirm": "Un levier supérieur à 20x nécessite une double confirmation",
  "srv_trade_high_risk_confirm": "Un risque supérieur à 15% nécessite une confirmation Risque élevé",
  "srv_trade_high_liquidation_risk": "Risque de liquidation élevé",
  "srv_trade_no_fee": "Aucun frais (détenu 7+ jours).",
  "srv_insufficient_data": "Pas assez de données de bougies pour ce backtest",
  "srv_notification_not_found": "Notification introuvable",
  "srv_nft_image_failed": "Échec de la génération d’image",
  "ntf_cloud_enabled": "Trading cloud activé — le bot fonctionne 24/7.",
  "ntf_cloud_disabled": "Trading cloud désactivé.",
  "srv_trade_no_price": "Aucun prix disponible pour {symbol}",
  "srv_trade_risk_lock": "Verrouillage du risque : max {pct}% du solde par trade",
  "srv_trade_max_leverage": "Le levier max pour {symbol} est {max}x",
  "srv_trade_risk_range": "Le risque pour {symbol} doit être compris entre 1% et {max}%",
  "srv_payment_unsupported_currency": "Devise non prise en charge. Choisissez parmi : {list}",
  "srv_exchange_unsupported_named": "Exchange non pris en charge : {name}",
  "srv_auth_username_cooldown": "Le nom d’utilisateur pourra être modifié dans {days} jour(s)",
  "srv_exchange_connection_error": "Erreur de connexion : {error}",
  "srv_trade_early_fee": "Frais de retrait anticipé de 5% ({fee}) appliqués.",
  "ntf_risk_drawdown": "Le drawdown max de {dd}% a atteint la limite de {limit}%. Toutes les positions sont fermées. Bot arrêté.",
  "ntf_risk_losses": "{count} pertes consécutives. Bot arrêté. Confirmez pour reprendre.",
  "ntf_cooldown": "Pause après {count} pertes consécutives — nouvelles entrées suspendues pendant {minutes} min.",
  "ntf_trade_opened": "Trade ouvert : {symbol} {timeframe} · score {score} · {leverage}",
  "ntf_nft_opened": "Position NFT ouverte (Démo) : {name}",
  "ntf_nft_closed": "Position NFT fermée (Démo) : P&L {pnl}",
  "ntf_trade_closed": "{reason} : {symbol} fermé · P&L {pnl}",
  "ntf_opportunity": "⚠️ {symbol} · {timeframe} · {action} · Score {score}. Entrée ${entry} / TP ${tp} / SL ${sl}. À titre informatif uniquement — pas un conseil financier.",
  "app_name": "FIREBIRD AI",
  "tagline": "Trading crypto et NFT par IA",
  "login": "Se connecter",
  "register": "S'inscrire",
  "logout": "Se déconnecter",
  "email": "E-mail",
  "password": "Mot de passe",
  "name": "Nom",
  "welcome_back": "Bon retour, trader",
  "create_account": "Créez votre compte",
  "no_account": "Pas encore de compte ?",
  "have_account": "Vous avez déjà un compte ?",
  "account_created": "Compte créé — démo de 100 $ prête",
  "loading": "Chargement…",
  "demo_mode": "Mode démo",
  "demo_balance": "Solde démo",
  "nav_dashboard": "Tableau de bord",
  "nav_charts": "Graphiques en direct",
  "nav_signals": "Signaux IA",
  "nav_autotrade": "Trading automatique",
  "nav_manual": "Trading manuel",
  "nav_scanner": "Scanner de memecoins",
  "nav_backtest": "Backtest 5×5",
  "nav_positions": "Positions et rapports",
  "nav_nft": "Collection NFT",
  "nav_assistant": "Assistant IA",
  "nav_settings": "Plateforme et paramètres",
  "nav_subscription": "Offre Premium",
  "subscription_subtitle": "Débloquez l'intelligence de trading premium — payez en crypto.",
  "current_plan": "Offre actuelle",
  "premium": "Premium",
  "free_plan": "Offre gratuite",
  "renews_on": "Renouvellement le",
  "active": "Actif",
  "best_value": "Meilleure offre",
  "plan_monthly": "Mensuel",
  "plan_annual": "Annuel",
  "plan_test": "Essai",
  "days": "jours",
  "pay_with_crypto": "Payer en crypto",
  "opening_checkout": "Ouverture du paiement…",
  "gateway_not_ready": "La passerelle de paiement crypto n'est pas encore configurée. Le paiement Premium sera activé une fois les clés API NOWPayments ajoutées.",
  "premium_only": "Réservé Premium",
  "premium_gate_desc": "Cette fonctionnalité fait partie de FireBird Premium. Passez à l'offre supérieure pour débloquer tous les signaux IA, l'auto-trade et le scanner d'opportunités.",
  "go_premium": "Passer Premium",
  "billing_history": "Historique de facturation",
  "no_invoices": "Aucune facture pour le moment. Vos paiements en crypto apparaîtront ici.",
  "date": "Date",
  "plan_col": "Offre",
  "amount_col": "Montant",
  "status_col": "Statut",
  "view_invoice": "Voir la facture",
  "check_status": "Vérifier le statut du paiement",
  "checking": "Vérification…",
  "payment_still_pending": "Paiement pas encore confirmé. Nous continuerons à vérifier automatiquement.",
  "status_paid": "Payé",
  "status_created": "En attente",
  "status_partially_paid": "Partiellement payé",
  "status_expired": "Expiré",
  "status_failed": "Échoué",
  "status_refunded": "Remboursé",
  "status_cancelled": "Annulé",
  "status_canceled": "Annulé",
  "payment_processing": "Paiement détecté — activation de votre offre Premium…",
  "payment_success": "Premium activé. Bienvenue à bord !",
  "payment_cancelled": "Paiement annulé.",
  "payment_error": "Impossible de démarrer le paiement. Veuillez réessayer.",
  "popup_blocked": "Le paiement est prêt. Si un nouvel onglet ne s'est pas ouvert, utilisez le lien ci-dessous.",
  "checkout_opened_hint": "Le paiement s'est ouvert dans un nouvel onglet. Vous ne le voyez pas ?",
  "open_checkout": "Ouvrir le paiement",
  "pay_currency_label": "Payer avec",
  "pay_currency_hint": "Nous acceptons l'USDC sur Solana et le BNB sur BSC. L'actif choisi est verrouillé au paiement.",
  "feat_signals": "Signaux IA complets (crypto, shitcoins, NFT)",
  "feat_autotrade": "Auto-Trade avec gestion des risques",
  "feat_scanner": "Scanner de memecoins et d'opportunités",
  "feat_alerts": "Alertes e-mail intelligentes",
  "feat_priority": "Envoi prioritaire des signaux",
  "feat_save": "2 mois offerts par rapport au mensuel",
  "feat_test_quick": "Test unique de 1 $ — vérifie le flux de paiement réel",
  "demo_account_settings": "Paramètres du compte démo",
  "demo_settings_desc": "Définissez un solde démo personnalisé et réinitialisez votre compte de paper trading. Cela n'affecte que les données démo — jamais votre abonnement ni le trading réel.",
  "custom_demo_balance": "Solde démo personnalisé (USDC)",
  "demo_min_hint": "Par défaut 500 · minimum 100",
  "reset_demo_account": "Réinitialiser le compte démo",
  "reset_demo_confirm_title": "Réinitialiser le compte démo ?",
  "reset_demo_confirm_desc": "Votre solde démo sera fixé à ${bal}, tous les trades démo et l'historique P/L seront supprimés, et les statuts de drawdown, d'arrêt et de pause seront effacés. Cette action est irréversible. Votre abonnement et vos données réelles ne sont pas affectés.",
  "demo_reset_done": "Compte démo réinitialisé — solde fixé à ${bal}",
  "demo_min_balance_error": "Le solde démo minimum est de 100",
  "nav_guide": "Guide du débutant",
  "owner_console": "Console propriétaire",
  "total_value": "Valeur totale",
  "cash": "Liquidités",
  "holdings": "Avoirs",
  "unrealized_pnl": "PnL latent",
  "top_signals": "Meilleurs signaux IA",
  "market_overview": "Aperçu du marché",
  "whale_activity": "Baleines et smart money",
  "market_pulse": "Pouls du marché",
  "news_up": "{name} grimpe de {pct} % en 24 h",
  "news_down": "{name} chute de {pct} % en 24 h",
  "kind_cex": "CEX",
  "kind_iranian_cex": "CEX iranien",
  "kind_dex": "DEX",
  "price": "Prix",
  "change_24h": "24 h",
  "score": "Score",
  "action": "Action",
  "buy": "Acheter",
  "sell": "Vendre",
  "hold": "Conserver",
  "timeframe": "Unité de temps",
  "symbol": "Symbole",
  "amount_usd": "Montant (USD)",
  "open_position": "Ouvrir une position",
  "close": "Fermer",
  "no_positions": "Aucune position ouverte",
  "entry": "Entrée",
  "current": "Actuel",
  "exit": "Sortie",
  "reason": "Raison",
  "pnl": "PnL",
  "win_rate": "Taux de réussite",
  "total_trades": "Total des trades",
  "total_pnl": "PnL total",
  "wl": "G / P",
  "open_label": "Ouverte",
  "run_backtest": "Lancer le backtest",
  "running": "En cours…",
  "bt_subtitle": "Stratégie testée sur 5 fenêtres historiques par unité de temps.",
  "window_results": "Résultats par fenêtre",
  "window": "Fenêtre",
  "trades": "Transactions",
  "return_label": "Rendement",
  "max_drawdown": "Drawdown max.",
  "auto_trade_on": "Auto-Trade actif",
  "auto_trade_off": "Auto-Trade désactivé",
  "enable_autotrade": "Activer l'Auto-Trade (démo)",
  "reset_demo": "Réinitialiser la démo (100 $)",
  "activity_log": "Journal d'activité",
  "waiting_signals": "En attente de signaux…",
  "enable_to_start": "Activez l'auto-trade pour démarrer",
  "reauthorize_bot": "Réautoriser le bot",
  "leverage": "Effet de levier",
  "high_leverage_warning": "Effet de levier élevé — vous pouvez perdre toute votre marge (liquidation).",
  "bot_description": "Le bot analyse toutes les cryptos sur 15m / 1h / 4h, entre sur le meilleur signal (rapport gain/risque 2:1, stop obligatoire) et gère les positions avec un take-profit suiveur en mode démo.",
  "rule_rr": "Gain:Risque 2:1 (stop obligatoire)",
  "rule_max_concurrent": "Max. 2 auto-trades simultanés",
  "rule_leverage": "Levier auto ≤ 10x · Manuel ≤ 50x",
  "rule_circuit": "Coupe-circuit à 20 % de drawdown",
  "rule_halt": "Arrêt après 5 pertes",
  "rule_scan": "Analyse toutes les cryptos et unités de temps",
  "rule_entry": "Score d'entrée ≥ {score} sur {tfs}",
  "rule_cooldown": "Pause de {min} min après {losses} pertes",
  "risk_status": "Statut du risque",
  "risk_mode_active": "Actif",
  "risk_mode_halted": "Arrêté",
  "consecutive_losses_label": "Pertes consécutives",
  "drawdown_label": "Repli",
  "open_positions_label": "Positions ouvertes",
  "max_concurrent_reached": "Nombre maximum de trades simultanés atteint.",
  "bot_reauthorized": "Bot réautorisé. Vous pouvez réactiver l'auto-trade.",
  "cloud_trading": "Trading cloud",
  "enable_cloud": "Activer le trading cloud",
  "disable_cloud": "Désactiver le trading cloud",
  "cloud_status": "Statut du cloud",
  "cloud_on": "En cours 24h/24, 7j/7",
  "cloud_off": "Désactivé",
  "cloud_desc": "Le bot tourne sur nos serveurs 24h/24, 7j/7, même lorsque votre appareil est éteint.",
  "notifications": "Notifications",
  "no_notifications": "Aucune notification pour le moment",
  "mark_all_read": "Tout marquer comme lu",
  "connect_exchange": "Connecter une plateforme",
  "api_key": "Clé API",
  "api_secret": "Secret API",
  "api_key_optional": "Clé API (facultative pour les prix publics)",
  "connect": "Connecter",
  "test": "Tester",
  "remove": "Retirer",
  "verified": "Vérifié",
  "not_verified": "Non vérifié",
  "connected_exchanges": "Plateformes connectées",
  "aggregated_balances": "Soldes · Toutes les plateformes",
  "aggregated_prices": "Prix en direct · Toutes les plateformes",
  "no_connections": "Aucune plateforme connectée pour le moment.",
  "connect_wallet": "Connecter un wallet",
  "wallet_connected": "Wallet connecté",
  "wallet_note": "Non custodial — nous ne stockons jamais vos clés privées.",
  "wallet_security": "Wallet et sécurité",
  "wallet_never_ask": "Nous ne demandons jamais votre clé privée ni votre phrase secrète.",
  "disconnect_wallet": "Déconnecter le wallet",
  "switch_chain": "Changer de réseau",
  "native_balance": "Solde natif",
  "wallet_chain": "Réseau",
  "dex_onchain": "DEX (on-chain)",
  "sign_in_wallet": "Se connecter avec le wallet",
  "waiting_signature": "En attente de la signature du wallet…",
  "dex_demo_note": "Vous signez avec votre propre wallet — les clés ne quittent jamais votre appareil.",
  "view_on_explorer": "Voir sur l'explorateur",
  "wallet_required_dex": "Connectez votre wallet pour trader on-chain.",
  "tx_pending": "Transaction en attente…",
  "tx_confirmed": "Transaction confirmée",
  "tx_failed": "Échec de la transaction",
  "connected_label": "Connecté",
  "not_connected_label": "Non connecté",
  "copy_address": "Copier l'adresse",
  "readonly_warning": "Créez votre clé API avec des autorisations en LECTURE SEULE. Désactivez le retrait et le trading.",
  "cex_security_notice": "Nous ne stockons JAMAIS vos clés privées et ne demandons aucune autorisation de retrait.",
  "api_passphrase_optional": "Phrase secrète (facultative)",
  "read_only_label": "Lecture seule",
  "how_to_create_key": "Comment créer une clé en lecture seule",
  "connected_wallets": "Wallets connectés",
  "no_wallet_connected": "Aucun wallet connecté.",
  "no_exchange_linked": "Aucune plateforme liée.",
  "smart_contract_allowances": "Autorisations de smart contracts",
  "no_allowances": "Aucune autorisation active.",
  "revoke": "Révoquer",
  "max_spend": "Dépense max.",
  "link_readonly_hint": "Utilisez le panneau Connecter une plateforme pour lier une clé en lecture seule.",
  "vpn_notice": "Cette place de marché peut nécessiter un VPN pour les utilisateurs de certaines régions.",
  "ir_friendly": "Compatible Iran",
  "best_price": "Meilleur prix",
  "marketplace_listings": "Annonces de la place de marché",
  "tab_opps": "Opportunités",
  "opportunities": "Opportunités",
  "high_opportunity": "Opportunité élevée",
  "alerts_triggered_today": "alertes déclenchées aujourd'hui",
  "score_range": "Plage de score",
  "timeframe_label": "Unité de temps",
  "direction_label": "Direction",
  "risk_disclaimer_title": "Avertissement sur les risques",
  "risk_disclaimer": "Les signaux sont fournis à titre informatif uniquement. Ce n'est PAS un conseil financier. 98 % des shitcoins échouent. Utilisez toujours un Stop Loss. Ne risquez jamais plus de 1 à 5 % par trade.",
  "no_opportunities": "Aucune opportunité pour le moment. Le scanner s'exécute toutes les 5 minutes.",
  "alerts_title": "Alertes",
  "enable_scanner": "Activer le scanner automatique",
  "min_score_label": "Score minimum",
  "monitor_timeframes": "Unités de temps à surveiller",
  "max_alerts_day": "Nombre max. d'alertes par jour",
  "notify_method_label": "Méthode de notification",
  "notify_in_app": "Dans l'app uniquement",
  "notify_in_app_email": "Dans l'app + e-mail",
  "alert_history_title": "Historique des alertes",
  "no_alert_history": "Aucune alerte pour le moment.",
  "nft_markets": "Places de marché NFT",
  "iran_friendly": "Compatible Iran",
  "key_security_note": "Les clés sont chiffrées sur le serveur et jamais stockées dans votre navigateur.",
  "exchange": "Plateforme",
  "no_balances": "Aucun solde (ajoutez des clés API pour charger les soldes en direct).",
  "safety": "Sécurité",
  "opportunity": "Opportunité",
  "holders": "Détenteurs",
  "verdict": "Verdict",
  "coin": "Crypto",
  "chain": "Chaîne",
  "scanning": "Analyse en cours…",
  "scanner_subtitle": "Memecoins sélectionnés avec une liquidité négociable (score ≥ 75). Aucun token inconnu ou frauduleux n'est affiché.",
  "safety_note": "Sécurité = verrouillage de la liquidité + renoncement au mint + répartition des détenteurs (indicatif, pas un conseil financier).",
  "ask_ai": "Demandez à Firebird AI...",
  "send": "Envoyer",
  "chat": "Discussion",
  "ai_empty": "Posez une question sur une crypto, une unité de temps ou une stratégie. Rien n'est un conseil financier.",
  "ai_thinking": "Firebird AI réfléchit…",
  "ai_error": "Désolé, je n'ai pas pu répondre pour le moment.",
  "score_coin": "Évaluer cette crypto",
  "any_coin_symbol": "N'importe quel symbole de crypto",
  "analyzing": "Analyse en cours…",
  "entry_strategy": "Entrée",
  "exit_strategy": "Sortie",
  "risk": "Risque",
  "signals_subtitle": "IA + scoring technique sur toutes les cryptos",
  "momentum": "Momentum",
  "simulated_feed": "flux simulé",
  "collection": "Collection Firebird 555",
  "nft_subtitle": "Firebird / Phénix — 555 pièces · 6 raretés légendaires · chacune avec sa propre histoire de destruction et de renaissance",
  "rares": "Raretés légendaires",
  "floor_price": "Prix plancher",
  "minted": "Mintés",
  "total_supply": "Offre totale",
  "rarity": "Rareté",
  "bt_download": "Télécharger",
  "bt_stop_loss": "Stop loss (TP = 2× SL)",
  "bt_min_score": "Score de signal min",
  "bt_share": "Partager",
  "bt_history": "Exécutions de backtest enregistrées",
  "bt_card_saved": "Carte de résultat téléchargée",
  "bt_compare_tf": "Comparer les unités de temps",
  "bt_best": "MEILLEUR",
  "bt_worst": "PIRE",
  "bt_run_all": "Lancer toutes les cryptos",
  "bt_by_section": "Résultats par section",
  "bt_per_coin": "Résultats par crypto",
  "bt_avg_return": "Rendement moy.",
  "bt_skipped": "Ignoré (pas assez de données)",
  "bt_sec_major": "Principale",
  "bt_sec_shitcoin": "Shitcoin",
  "bt_sec_meme": "Mème",
  "bt_sec_nft": "Tokens NFT",
  "bt_sec_other": "Autre",
  "bt_data_live": "Données de marché EN DIRECT",
  "bt_data_simulated": "Données SIMULÉES (marché en direct indisponible)",
  "risk_per_trade": "Risque par trade",
  "max_amount": "Max.",
  "tier_major": "Majeures",
  "tier_mid": "Moyenne capitalisation",
  "tier_meme": "Mème/Pump",
  "high_risk_ack": "Je comprends qu'il s'agit d'un trade à Haut Risque (plus de 15 % de mon solde).",
  "lev_warn_yellow": "Risque de liquidation élevé",
  "lev_warn_red": "Levier extrême — risque de liquidation très élevé. Double confirmation requise.",
  "lev_ack": "Je comprends que je peux perdre toute ma marge.",
  "lev_confirm_again": "Levier extrême : appuyez à nouveau pour confirmer.",
  "confirm_again": "Confirmer à nouveau",
  "high_risk_required": "Veuillez cocher la confirmation Haut Risque.",
  "lev_ack_required": "Veuillez confirmer l'avertissement de levier extrême.",
  "trait_element": "Élément",
  "trait_aura": "Aura",
  "trait_background": "Arrière-plan",
  "prev": "Préc.",
  "next": "Suiv.",
  "all": "Tout",
  "save": "Enregistrer",
  "risk_lock": "Verrou de risque",
  "max_position": "Position max. %",
  "trailing_stop": "Stop suiveur %",
  "take_profit": "Take Profit %",
  "stop_loss": "Stop Loss %",
  "risk_strategy": "Risque et stratégie",
  "exchanges": "Connexions aux plateformes",
  "connected": "Connecté",
  "disconnected": "Non connecté",
  "withdraw_demo_wallet": "Retrait (wallet démo)",
  "withdraw_fee_note": "Un retrait effectué moins de 7 jours après votre dernier dépôt entraîne des frais de retrait anticipé de 5 % (part du propriétaire).",
  "withdraw": "Retirer",
  "trade_history": "Historique des trades",
  "no_closed_trades": "Aucun trade clôturé pour le moment",
  "owner_subtitle": "Performance de tous les utilisateurs en lecture seule · registre des commissions (2 % par trade gagnant, règlement hebdomadaire · 5 % de frais de retrait anticipé)",
  "total_users": "Utilisateurs au total",
  "total_commission": "Commission totale",
  "this_week": "Cette semaine",
  "total_volume": "Volume total",
  "all_time": "depuis le début",
  "settles_weekly": "règlement hebdomadaire",
  "commission_breakdown": "Détail des commissions",
  "from_trade_profits": "Sur les gains des trades (2 %)",
  "from_withdrawal_fees": "Sur les frais de retrait anticipé (5 %)",
  "owner_rate": "Taux du propriétaire",
  "settlement": "Règlement",
  "early_exit_fee": "Frais de sortie anticipée",
  "weekly": "Hebdomadaire",
  "daily_accrual": "Cumul quotidien",
  "no_commission_yet": "Pas encore de commission — elle s'accumule sur les trades gagnants.",
  "users_performance": "Performance des utilisateurs (lecture seule)",
  "col_user": "Utilisateur",
  "col_role": "Rôle",
  "col_joined": "Inscrit le",
  "col_volume": "Volume",
  "col_balance": "Solde",
  "role_owner": "propriétaire",
  "role_user": "utilisateur",
  "guide_intro": "Bienvenue sur Firebird AI Trade. Suivez ces étapes pour démarrer en toute sécurité.",
  "guide_step": "Étape",
  "guide1_title": "Le mode démo est activé",
  "guide1_desc": "Vous commencez avec un solde démo de 100 $. Aucun argent réel n'est utilisé tant que vous n'activez pas explicitement le trading réel avec vos propres clés sécurisées.",
  "guide2_title": "Consultez le tableau de bord",
  "guide2_desc": "Visualisez la valeur du portefeuille, les meilleurs signaux IA, l'aperçu du marché, l'activité des baleines et le pouls du marché au même endroit.",
  "guide3_title": "Consultez les signaux IA",
  "guide3_desc": "Les cryptos sont notées de 0 à 100 selon le RSI, les croisements de SMA et le momentum sur plusieurs unités de temps.",
  "guide4_title": "Interrogez l'assistant IA",
  "guide4_desc": "Obtenez le score d'une crypto avec stratégie d'entrée/sortie et notes de risque de Firebird AI Core (GPT-5.6).",
  "guide5_title": "Essayez l'Auto-Trade (démo)",
  "guide5_desc": "Laissez le bot ouvrir des positions d'ACHAT sur les signaux forts et les gérer avec un trailing stop / take-profit.",
  "guide6_title": "Scannez les memecoins",
  "guide6_desc": "Seuls les memecoins négociables avec de bons scores de sécurité sont affichés — aucun token inconnu ou frauduleux.",
  "guide7_title": "Explorez les NFT Firebird 555",
  "guide7_desc": "Parcourez la collection de 555 phénix avec 6 raretés légendaires.",
  "disclaimer": "Mode démo/sandbox. Rien ici n'est un conseil financier. Aucun système ne peut garantir de futurs taux de réussite.",
  "src_manual": "Manuel",
  "src_auto": "Auto",
  "tier_legendary": "Légendaire",
  "tier_epic": "Épique",
  "tier_rare": "Rare",
  "tier_common": "Commun",
  "verdict_tradeable": "Négociable",
  "verdict_watch": "À surveiller",
  "pressure_accumulation": "Accumulation",
  "pressure_distribution": "Distribution",
  "reason_take_profit": "Take Profit",
  "reason_liquidation": "Liquidation",
  "reason_stop_loss": "Stop Loss",
  "reason_trailing_take_profit": "Take Profit suiveur",
  "reason_trailing_stop": "Stop suiveur",
  "reason_signal_flip": "Inversion de signal",
  "welcome": "Bienvenue",
  "trader": "trader",
  "live": "En direct",
  "verify_email_banner": "Vérifiez votre e-mail pour ouvrir des trades. Consultez votre boîte de réception pour le lien de vérification.",
  "resend": "Renvoyer",
  "verification_sent": "E-mail de vérification envoyé",
  "could_not_resend": "Impossible de renvoyer",
  "search_coin_placeholder": "Rechercher une crypto (p. ex. BTC, PEPE, ARB)",
  "add_to_watchlist": "Ajouter à la liste de suivi",
  "free_balance": "Solde disponible",
  "in_positions": "En positions",
  "total_equity": "Capital total",
  "watchlist": "Liste de suivi",
  "watchlist_empty": "Aucune crypto pour le moment — recherchez et appuyez sur + pour ajouter.",
  "high_exposure": "Utilisation de {percent} % de votre solde disponible — exposition élevée.",
  "advanced_tpsl": "TP / SL avancé",
  "entry_optional": "Entrée (facultatif — au marché par défaut)",
  "market": "marché",
  "take_profit_price": "Prix du Take Profit",
  "stop_loss_price": "Prix du Stop Loss",
  "tp_example": "p. ex. 72000",
  "sl_example": "p. ex. 66000",
  "if_tp_hits": "Si le TP est atteint",
  "if_sl_hits": "Si le SL est atteint",
  "pnl_preview_note": "Basé sur ${amount} de marge × {leverage}x. Lignes tracées sur le graphique →",
  "clear_tpsl": "Effacer TP/SL",
  "one_tap_trade": "Trade en un clic",
  "tp_short": "TP",
  "sl_short": "SL",
  "auto_signals": "Signaux automatiques",
  "add_token_placeholder": "Ajoutez n'importe quel token (p. ex. ARB, OP, TIA)",
  "analyze": "Analyser",
  "analyzing_on": "Analyse de {symbol} sur {tf}…",
  "tap_to_load": "Appuyez pour charger sur le graphique →",
  "scanning_market": "Analyse du marché…",
  "no_signals": "Aucun signal pour le moment.",
  "money_depth": "Flux d'argent",
  "sr_zones": "Zones S/R",
  "bot_analysis": "Analyse du bot",
  "confidence": "Confiance",
  "reasoning": "Raisonnement",
  "tp_label": "Take Profit",
  "sl_label": "Stop Loss",
  "risk_reward": "Risque : Gain",
  "levels_from_position": "Niveaux en direct de votre position ouverte",
  "levels_suggested": "Niveaux suggérés · pas un conseil financier",
  "toast_opened": "Position {symbol} {leverage}x ouverte",
  "toast_closed": "{symbol} clôturé · PnL ${pnl}",
  "toast_closed_pnl": "Clôturé · PnL ${pnl}",
  "ago_s": "il y a {n} s",
  "ago_m": "il y a {n} min",
  "ago_h": "il y a {n} h",
  "ago_d": "il y a {n} j",
  "in_label": "Entrant",
  "out_label": "Sortant",
  "confirm_reveal_email": "Afficher l'e-mail de cet utilisateur ? Les e-mails sont privés — ne les consultez que si nécessaire.",
  "view_email_private": "Voir l'e-mail (privé)",
  "display_name_updated": "Nom d'affichage mis à jour",
  "change_email_sent": "Lien de vérification envoyé au nouvel e-mail",
  "username_updated": "Nom d'utilisateur mis à jour",
  "password_changed": "Mot de passe modifié. Reconnectez-vous sur vos autres appareils.",
  "confirm_logout_all": "Se déconnecter de tous les appareils ? Vous devrez vous reconnecter.",
  "no_wallet": "Aucune extension de wallet détectée (MetaMask/WalletConnect).",
  "wallet_rejected": "Connexion du wallet refusée.",
  "profile_security": "Profil et sécurité",
  "display_name": "Nom d'affichage",
  "display_name_optional": "Nom d'affichage (facultatif)",
  "edit": "Modifier",
  "cancel": "Annuler",
  "change": "Changer",
  "in_days": "Dans {days} j",
  "username_label": "Nom d'utilisateur",
  "username_hint": "3 à 20 lettres, chiffres ou tirets bas. Modifiable une fois tous les 30 jours.",
  "username_example": "p. ex. arash_king",
  "email_private": "E-mail (privé)",
  "change_email": "Changer l'e-mail",
  "unverified": "Non vérifié",
  "resend_verification": "Renvoyer la vérification",
  "new_email": "Nouvel e-mail",
  "current_password": "Mot de passe actuel",
  "new_password": "Nouveau mot de passe",
  "confirm_new_password": "Confirmer le nouveau mot de passe",
  "send_verification_new": "Envoyer la vérification au nouvel e-mail",
  "change_email_hint": "Vous confirmerez via un lien envoyé au nouvel e-mail, puis vous vous reconnecterez.",
  "email_private_hint": "Votre e-mail n'est jamais affiché publiquement. Vous seul pouvez le voir ici.",
  "sessions": "Sessions",
  "logout_all_devices": "Se déconnecter de tous les appareils",
  "change_password": "Changer le mot de passe",
  "pw_hint": "8 caractères min., une lettre et un chiffre.",
  "update_password": "Mettre à jour le mot de passe",
  "coin_example_placeholder": "p. ex. BTC, PEPE, TAO...",
  "username_or_email": "Nom d'utilisateur ou e-mail",
  "forgot_password_q": "Mot de passe oublié ?",
  "invalid_email": "Saisissez un e-mail valide",
  "pw_mismatch": "Les mots de passe ne correspondent pas",
  "username_hint_short": "3 à 20 lettres, chiffres ou tirets bas",
  "account_created_verify": "Compte créé ! Vérifiez votre e-mail pour valider votre compte.",
  "confirm_password_label": "Confirmer le mot de passe",
  "missing_verify_token": "Jeton de vérification manquant.",
  "email_verified_msg": "E-mail vérifié !",
  "verification_failed": "Échec de la vérification.",
  "verifying_email": "Vérification de votre e-mail…",
  "email_verified_title": "E-mail vérifié",
  "go_to_login": "Aller à la connexion",
  "verification_failed_title": "Échec de la vérification",
  "verify_expired_hint": "Lien expiré ? Connectez-vous et utilisez « Renvoyer la vérification » dans les paramètres.",
  "back_to_login": "← Retour à la connexion",
  "forgot_password": "Mot de passe oublié",
  "forgot_subtitle": "Saisissez votre nom d'utilisateur ou votre e-mail et nous vous enverrons un lien de réinitialisation.",
  "forgot_sent_toast": "Si le compte existe, un lien de réinitialisation a été envoyé.",
  "forgot_sent_full": "Si le compte existe, un lien de réinitialisation a été envoyé. Vérifiez votre e-mail (valable 15 minutes).",
  "send_reset_link": "Envoyer le lien de réinitialisation",
  "remembered_it": "Vous vous en souvenez ?",
  "missing_reset_token": "Jeton de réinitialisation manquant. Utilisez le lien de votre e-mail.",
  "pw_requirement": "Le mot de passe doit contenir au moins 8 caractères, dont une lettre et un chiffre",
  "password_updated": "Mot de passe mis à jour.",
  "reset_password": "Réinitialiser le mot de passe",
  "reset_subtitle": "Choisissez un nouveau mot de passe pour votre compte.",
  "reset_invalid": "Lien de réinitialisation invalide ou manquant. Demandez-en un nouveau.",
  "request_reset_link": "Demander un lien de réinitialisation",
  "new_password_label": "Nouveau mot de passe",
  "pw_hint2": "Au moins 8 caractères, dont une lettre et un chiffre.",
  "update_password_btn": "Mettre à jour le mot de passe",
  "bullish": "Haussier",
  "bearish": "Baissier",
  "inflow": "entrée",
  "outflow": "sortie",
  "volume_up": "Volume en hausse",
  "volume_down": "Volume en baisse",
  "money_flow_mfi": "Flux d'argent (MFI 14)",
  "flow_overbought": "Surachat",
  "flow_oversold": "Survente",
  "flow_bullish": "Entrée haussière",
  "flow_bearish": "Sortie baissière",
  "support": "Support",
  "resistance": "Résistance",
  "available_for_trade": "Disponible pour trader",
  "free_balance_after": "Solde disponible après",
  "tab_major": "Majeures",
  "tab_shitcoins": "Shitcoins",
  "tab_nfts": "NFT",
  "filter_direction": "Direction",
  "buy_only": "Achat uniquement",
  "sell_only": "Vente uniquement",
  "min_confidence": "Confiance min.",
  "confirm": "Confirmer",
  "safety_score": "Score de sécurité",
  "liquidity_lock": "Verrouillage de la liquidité",
  "locked": "Verrouillée",
  "unlocked": "Déverrouillée",
  "honeypot": "Pot de miel",
  "honeypot_safe_label": "Sûr",
  "honeypot_risk": "Risque",
  "nft_demo_notice": "Trade démo — aucun vrai NFT ne sera acheté",
  "view_on_opensea": "Voir sur OpenSea",
  "volume_24h": "Volume (24 h)",
  "nft_position_opened": "Position NFT ouverte (démo)",
  "crypto_positions_title": "Positions crypto et shitcoins",
  "nft_positions_title": "Positions NFT",
  "min_safety_required": "Le score de sécurité doit être ≥ 75 pour trader",
  "amount_exceeds_balance": "Le montant dépasse votre solde disponible",
  "amount_gt_zero": "Le montant doit être supérieur à 0",
  "confirm_trade": "Confirmer le trade",
  "usd_equiv": "≈",
  "nft_badge": "NFT",
  "no_nft_positions": "Aucune position NFT ouverte",
  "floor": "Plancher",
  "rr_short": "G:R",
  "best_marketplace": "Meilleur marché",
  "story": "Histoire",
  "show_more": "Afficher plus",
  "show_less": "Afficher moins",
  "view_chart": "Voir le graphique",
  "reason_sma_bull": "SMA9 au-dessus de SMA21 (tendance haussière)",
  "reason_sma_bear": "SMA9 en dessous de SMA21 (tendance baissière)",
  "reason_rsi_oversold": "survendu",
  "reason_rsi_overbought": "suracheté",
  "reason_rsi_neutral": "neutre",
  "reason_pos_momentum": "Momentum positif",
  "reason_neg_momentum": "Momentum négatif",
  "reason_insufficient": "Données insuffisantes",
  "reason_whale_accum": "Accumulation par les baleines",
  "reason_rising_floor": "Plancher en hausse",
  "reason_falling_floor": "Plancher en baisse",
  "reason_high_rarity": "Rareté élevée",
  "reason_mid_rarity": "Rareté moyenne",
  "nft_trade_history": "Historique des trades NFT",
  "no_nft_trades": "Aucun trade NFT clôturé pour le moment",
  "entry_floor": "Plancher d'entrée",
  "exit_floor": "Plancher de sortie",
  "verify_reminder": "Votre e-mail n'est pas encore vérifié — vérifiez-le pour débloquer le trading.",
  "verify_now": "Vérifier maintenant",
  "dismiss": "Ignorer",
  "trusted_devices": "Sessions actives · Appareils connectés",
  "font_size": "Taille de police",
  "font_small": "Petite",
  "font_medium": "Moyenne",
  "font_large": "Grande",
  "sessions_hint": "Téléphones et navigateurs actuellement connectés à votre compte (pas des clés API de plateforme).",
  "unknown_device": "Appareil inconnu",
  "this_device": "Cet appareil",
  "current_session": "Actuel",
  "last_active": "Dernière activité",
  "revoke_all_others": "Déconnecter tous les autres appareils",
  "revoke_all_others_done": "Déconnecté de tous les autres appareils",
  "no_other_devices": "Aucun autre appareil actif",
  "device_revoked": "Appareil déconnecté",
  "ui_logo_alt": "Logo de trading Firebird / Simorgh",
  "ui_logo_switch_hint": "Touchez pour changer de logo",
  "ui_vpn_info": "Informations VPN"
};
export default fr;
